import { PaymentProcessorEnum } from '@systemeio/ui'
import { SubscriptionId } from 'modules/payment/subscriptions/types/subscription-interface'
import { PaystackPaymentProcessor } from 'modules/profile/payment-gateways/integrations/paystack/types'
import { PaymentItemInterface } from 'shared/types/payment-interface'
import {
  cancelGocardlessSubscription,
  cancelPaystackSubscription,
  cancelSecureAndPaySubscription,
  cancelSubscription,
  cancelXenditSubscription,
} from '../api/cancel-subscriptions-api'

const getGocardlessCancelSubscriptionHandler = (subscriptionId: SubscriptionId) => {
  return () => cancelGocardlessSubscription(subscriptionId)
}

const getXenditCancelSubscriptionHandler = (subscriptionId: SubscriptionId) => {
  return () => cancelXenditSubscription(subscriptionId)
}

const getPaystackCancelSubscriptionHandler = (
  subscriptionId: SubscriptionId,
  paymentProcessorName: PaystackPaymentProcessor,
) => {
  return () => cancelPaystackSubscription(subscriptionId, paymentProcessorName)
}

const getDefaultCancelSubscriptionHandler = (subscriptionItemId: PaymentItemInterface['id']) => {
  return () => cancelSubscription(subscriptionItemId)
}

export const getCancelSubscriptionApiHandler = (
  paymentProcessor: PaymentProcessorEnum,
  subscriptionId: SubscriptionId,
  subscriptionItemId: PaymentItemInterface['id'],
) => {
  switch (paymentProcessor) {
    case PaymentProcessorEnum.Gocardless: {
      return getGocardlessCancelSubscriptionHandler(subscriptionId)
    }
    case PaymentProcessorEnum.XenditPH:
    case PaymentProcessorEnum.XenditID: {
      return getXenditCancelSubscriptionHandler(subscriptionId)
    }
    case PaymentProcessorEnum.PaystackZA:
    case PaymentProcessorEnum.PaystackKE:
    case PaymentProcessorEnum.PaystackEG:
    case PaymentProcessorEnum.PaystackNG:
    case PaymentProcessorEnum.PaystackGH:
    case PaymentProcessorEnum.PaystackCI: {
      return getPaystackCancelSubscriptionHandler(subscriptionId, paymentProcessor)
    }
    case PaymentProcessorEnum.SecureAndPay:
      return () => cancelSecureAndPaySubscription(subscriptionId)
    default: {
      return getDefaultCancelSubscriptionHandler(subscriptionItemId)
    }
  }
}
